
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-bdbcbfa4!../node_modules/vue-loader/lib/selector?type=styles&index=0!./NaviBar.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./NaviBar.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-bdbcbfa4!../node_modules/vue-loader/lib/selector?type=template&index=0!./NaviBar.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/NaviBar.vue
// module id = 648
// module chunks = 0